export default "/profile/images/echat-logo.svg?0eb94c5b1fe787a90d5b0fed74fe8ec7";